import React, { useState, useRef, useMemo, useEffect } from 'react';
import '../../CSS/ReportDefinition.css';

/* ════════ PARTIES & JOBS ════════ */
const PARTIES = [
  { code: 'TML', name: 'Tata Motors Ltd' }, { code: 'BAL', name: 'Bajaj Auto Ltd' },
  { code: 'MSI', name: 'Maruti Suzuki India Ltd' }, { code: 'BSH', name: 'Bosch Ltd' },
  { code: 'MNL', name: 'Motherson Sumi Ltd' }, { code: 'SVP', name: 'Sundaram Valeo Ltd' },
];
const JOBS = {
  TML: [{ code: 'JOB-TML-01', name: 'Spare Parts Distribution' }, { code: 'JOB-TML-02', name: 'Inbound Line Feed' }],
  BAL: [{ code: 'JOB-BAL-01', name: '2W Spares Movement' }, { code: 'JOB-BAL-02', name: 'Export Packing' }],
  MSI: [{ code: 'JOB-MSI-01', name: 'Genuine Parts Dispatch' }],
  BSH: [{ code: 'JOB-BSH-01', name: 'Auto Components' }, { code: 'JOB-BSH-02', name: 'Service Exchange' }],
  MNL: [{ code: 'JOB-MNL-01', name: 'Wiring Harness Supply' }],
  SVP: [{ code: 'JOB-SVP-01', name: 'Cooling Systems OEM' }],
};

/* ════════ MASTER FIELD LIST ════════ */
const FIELDS = [
  // Consignment
  { id: 'cnr', name: 'Consignment Number', cat: 'Consignment', type: 'text' },
  { id: 'bkbranch', name: 'Booking Branch', cat: 'Consignment', type: 'text' },
  { id: 'bkplace', name: 'Booking Place', cat: 'Consignment', type: 'text' },
  { id: 'dlplace', name: 'Delivery Place', cat: 'Consignment', type: 'text' },
  { id: 'service', name: 'Service Type', cat: 'Consignment', type: 'text' },
  { id: 'mode', name: 'Mode (LTL / FTL)', cat: 'Consignment', type: 'text' },
  { id: 'route', name: 'Route (D2D / D2P)', cat: 'Consignment', type: 'text' },
  // Booking
  { id: 'bkdate', name: 'Booking Date', cat: 'Booking', type: 'date' },
  { id: 'bktime', name: 'Booking Time', cat: 'Booking', type: 'text' },
  { id: 'bkref', name: 'Booking Reference', cat: 'Booking', type: 'text' },
  { id: 'invno', name: 'Invoice Number', cat: 'Booking', type: 'text' },
  { id: 'invval', name: 'Invoice Value', cat: 'Booking', type: 'num' },
  { id: 'ewb', name: 'E-Way Bill No', cat: 'Booking', type: 'text' },
  // Cargo
  { id: 'pcs', name: 'Pcs', cat: 'Cargo', type: 'num' },
  { id: 'actwt', name: 'Actual Weight (Kg)', cat: 'Cargo', type: 'num' },
  { id: 'chgwt', name: 'Charged Weight (Kg)', cat: 'Cargo', type: 'num' },
  { id: 'cft', name: 'Volume / CFT', cat: 'Cargo', type: 'num' },
  { id: 'dims', name: 'Dimensions', cat: 'Cargo', type: 'text' },
  // Parties
  { id: 'consignor', name: 'Consignor Name', cat: 'Parties', type: 'text' },
  { id: 'consignee', name: 'Consignee Name', cat: 'Parties', type: 'text' },
  { id: 'cnaddr', name: 'Consignee Address', cat: 'Parties', type: 'text' },
  { id: 'cnmobile', name: 'Consignee Mobile', cat: 'Parties', type: 'text' },
  { id: 'cnpin', name: 'Consignee Pincode', cat: 'Parties', type: 'text' },
  { id: 'area', name: 'Delivery Area', cat: 'Parties', type: 'text' },
  // Charges
  { id: 'freight', name: 'Freight Amount', cat: 'Charges', type: 'num' },
  { id: 'other', name: 'Other Charges', cat: 'Charges', type: 'num' },
  { id: 'hamali', name: 'Hamali', cat: 'Charges', type: 'num' },
  { id: 'fov', name: 'FOV / Risk', cat: 'Charges', type: 'num' },
  { id: 'docket', name: 'Docket Charge', cat: 'Charges', type: 'num' },
  { id: 'gst', name: 'GST Amount', cat: 'Charges', type: 'num' },
  { id: 'amount', name: 'Amount', cat: 'Charges', type: 'num' },
  { id: 'total', name: 'Total Amount', cat: 'Charges', type: 'num' },
  { id: 'cod', name: 'COD Amount', cat: 'Charges', type: 'num' },
  // Delivery
  { id: 'dlstatus', name: 'Delivery Status', cat: 'Delivery', type: 'text' },
  { id: 'statusdate', name: 'Status Date', cat: 'Delivery', type: 'date' },
  { id: 'dldate', name: 'Delivered Date', cat: 'Delivery', type: 'date' },
  { id: 'receiver', name: 'Receiver Name', cat: 'Delivery', type: 'text' },
  { id: 'podstatus', name: 'POD Status', cat: 'Delivery', type: 'text' },
  { id: 'attempts', name: 'Attempt Count', cat: 'Delivery', type: 'num' },
  { id: 'drsno', name: 'DRS Number', cat: 'Delivery', type: 'text' },
  { id: 'dboy', name: 'Delivery Boy', cat: 'Delivery', type: 'text' },
  // Other
  { id: 'remarks', name: 'Remarks', cat: 'Other', type: 'text' },
  { id: 'createdby', name: 'Created By', cat: 'Other', type: 'text' },
];
const CATS = ['Consignment', 'Booking', 'Cargo', 'Parties', 'Charges', 'Delivery', 'Other'];
const SAMPLE = {
  cnr: 'STL-2604-00847', bkbranch: 'Mumbai', bkplace: 'Mumbai', dlplace: 'Latur', service: 'Surface', mode: 'LTL', route: 'D2D',
  bkdate: '18-Jun-2026', bktime: '10:24', bkref: 'REF-8841', invno: 'INV-2261', invval: '24,500.00', ewb: '2810 0042 7781',
  pcs: '3', actwt: '48.0', chgwt: '52.0', cft: '6.4', dims: '40×30×25',
  consignor: 'Tata Motors Ltd', consignee: 'Ashok Hotel', cnaddr: 'Near District Court, Latur', cnmobile: '98220 11847', cnpin: '413512', area: 'Latur',
  freight: '1,840.00', other: '350.00', hamali: '120.00', fov: '60.00', docket: '50.00', gst: '415.80', amount: '2,470.00', total: '2,885.80', cod: '0.00',
  dlstatus: 'Delivered', statusdate: '20-Jun-2026', dldate: '20-Jun-2026', receiver: 'Ramesh', podstatus: 'Uploaded', attempts: '1', drsno: 'DRS-2606-00231', dboy: 'Ravi Kumar',
  remarks: '—', createdby: 'EMP-1042',
};
const PRESET = ['cnr', 'bkdate', 'bkplace', 'dlplace', 'pcs', 'chgwt', 'amount', 'other', 'total', 'dlstatus', 'statusdate'];

const INITIAL_DEFS = [
  {
    party: 'TML', job: 'JOB-TML-01', name: 'Tata Spare Parts MIS', updated: '2026-06-22',
    cols: [{ id: 'cnr', label: 'Consignment No', total: false }, { id: 'bkdate', label: 'Booking Date', total: false }, { id: 'bkplace', label: 'Origin', total: false }, { id: 'dlplace', label: 'Destination', total: false }, { id: 'pcs', label: 'Pcs', total: true }, { id: 'chgwt', label: 'Chg. Wt', total: true }, { id: 'amount', label: 'Freight', total: true }, { id: 'total', label: 'Total', total: true }, { id: 'dlstatus', label: 'Status', total: false }, { id: 'statusdate', label: 'Status Date', total: false }],
  },
  {
    party: 'BSH', job: 'JOB-BSH-01', name: 'Bosch Delivery Report', updated: '2026-06-19',
    cols: [{ id: 'cnr', label: 'CN Number', total: false }, { id: 'consignee', label: 'Consignee', total: false }, { id: 'area', label: 'Area', total: false }, { id: 'pcs', label: 'Pcs', total: true }, { id: 'dlstatus', label: 'Delivery Status', total: false }, { id: 'receiver', label: 'Received By', total: false }, { id: 'dldate', label: 'Delivered On', total: false }],
  },
];

const fieldById = (id) => FIELDS.find((f) => f.id === id);

let toastSeq = 0;

export default function ReportDefinition() {
  const [defs, setDefs] = useState(INITIAL_DEFS);
  const [curParty, setCurParty] = useState('');
  const [curJob, setCurJob] = useState('');
  const [repName, setRepName] = useState('');
  const [selected, setSelected] = useState([]); // [{id,label,total}]
  const [availSearch, setAvailSearch] = useState('');
  const [toasts, setToasts] = useState([]);
  const dragIdx = useRef(null);

  const jobs = JOBS[curParty] || [];
  const partyObj = PARTIES.find((p) => p.code === curParty);
  const jobObj = jobs.find((j) => j.code === curJob);

  /* ════════ TOAST ════════ */
  function toast(msg, type) {
    const id = ++toastSeq;
    setToasts((t) => [...t, { id, msg, type: type || 'info', leaving: false }]);
    setTimeout(() => {
      setToasts((t) => t.map((x) => (x.id === id ? { ...x, leaving: true } : x)));
      setTimeout(() => {
        setToasts((t) => t.filter((x) => x.id !== id));
      }, 320);
    }, 2700);
  }
  const TOAST_ICONS = { ok: '✓', err: '✕', warn: '⚠', info: 'ℹ' };

  /* ════════ PARTY / JOB ════════ */
  function partyChanged(value) {
    setCurParty(value);
    setCurJob('');
  }
  function jobChanged(value) {
    setCurJob(value);
    const d = defs.find((x) => x.party === curParty && x.job === value);
    if (d) {
      setSelected(d.cols.map((c) => ({ ...c })));
      setRepName(d.name);
      toast('Loaded existing definition', 'info');
    }
  }

  /* ════════ AVAILABLE ════════ */
  const takenIds = useMemo(() => new Set(selected.map((s) => s.id)), [selected]);
  const availFields = useMemo(() => {
    const q = availSearch.toLowerCase().trim();
    return FIELDS.filter((f) => !takenIds.has(f.id) && (!q || f.name.toLowerCase().includes(q) || f.cat.toLowerCase().includes(q)));
  }, [availSearch, takenIds]);

  function addField(id) {
    if (selected.some((s) => s.id === id)) return;
    const f = fieldById(id);
    setSelected((s) => [...s, { id, label: f.name, total: false }]);
  }
  function addCat(cat) {
    setSelected((s) => {
      const existing = new Set(s.map((x) => x.id));
      const additions = FIELDS.filter((f) => f.cat === cat && !existing.has(f.id)).map((f) => ({ id: f.id, label: f.name, total: false }));
      return [...s, ...additions];
    });
  }
  function addAll() {
    setSelected((s) => {
      const existing = new Set(s.map((x) => x.id));
      const additions = FIELDS.filter((f) => !existing.has(f.id)).map((f) => ({ id: f.id, label: f.name, total: false }));
      return [...s, ...additions];
    });
    toast('All fields added', 'ok');
  }

  /* ════════ SELECTED ════════ */
  function removeField(i) {
    setSelected((s) => s.filter((_, idx) => idx !== i));
  }
  function clearAll() {
    if (!selected.length) return;
    if (!window.confirm('Remove all selected columns?')) return;
    setSelected([]);
  }
  function moveField(i, dir) {
    const j = i + dir;
    if (j < 0 || j >= selected.length) return;
    setSelected((s) => {
      const copy = [...s];
      [copy[i], copy[j]] = [copy[j], copy[i]];
      return copy;
    });
  }
  function setLabel(i, v) {
    setSelected((s) => s.map((item, idx) => (idx === i ? { ...item, label: v } : item)));
  }
  function setTotal(i, v) {
    setSelected((s) => s.map((item, idx) => (idx === i ? { ...item, total: v } : item)));
  }
  function loadPreset() {
    setSelected(PRESET.map((id) => {
      const f = fieldById(id);
      return { id, label: f.name, total: f.type === 'num' };
    }));
    toast('Standard consignment column set loaded', 'ok');
  }

  /* ════════ DRAG REORDER ════════ */
  const [dragOverIdx, setDragOverIdx] = useState(null);
  const [draggingIdx, setDraggingIdx] = useState(null);
  function dragStart(i) {
    dragIdx.current = i;
    setDraggingIdx(i);
  }
  function dragOver(e, i) {
    e.preventDefault();
    if (i !== dragIdx.current) setDragOverIdx(i);
  }
  function dragLeave() {
    setDragOverIdx(null);
  }
  function drop(e, i) {
    e.preventDefault();
    if (dragIdx.current === null || dragIdx.current === i) {
      dragEnd();
      return;
    }
    setSelected((s) => {
      const copy = [...s];
      const item = copy.splice(dragIdx.current, 1)[0];
      copy.splice(i, 0, item);
      return copy;
    });
    dragEnd();
  }
  function dragEnd() {
    dragIdx.current = null;
    setDraggingIdx(null);
    setDragOverIdx(null);
  }

  /* ════════ PREVIEW ════════ */
  const previewCols = selected.length + ' column' + (selected.length !== 1 ? 's' : '');
  const hasTotals = selected.some((s) => s.total);

  /* ════════ SAVE / LOAD ════════ */
  function saveDefinition() {
    if (!curParty) { toast('Select a party', 'warn'); return; }
    if (!curJob) { toast('Select a job', 'warn'); return; }
    if (!selected.length) { toast('Add at least one field', 'warn'); return; }
    const name = repName.trim() || 'Untitled Report';
    const rec = { party: curParty, job: curJob, name, updated: new Date().toISOString().slice(0, 10), cols: selected.map((s) => ({ ...s })) };
    setDefs((d) => {
      const idx = d.findIndex((x) => x.party === curParty && x.job === curJob);
      if (idx >= 0) {
        const copy = [...d];
        copy[idx] = rec;
        return copy;
      }
      return [...d, rec];
    });
    toast('Report definition saved — ' + selected.length + ' columns', 'ok');
  }
  function loadDef(party, job) {
    const d = defs.find((x) => x.party === party && x.job === job);
    if (!d) return;
    setCurParty(party);
    setCurJob(job);
    setSelected(d.cols.map((c) => ({ ...c })));
    setRepName(d.name);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    toast('Loaded "' + d.name + '"', 'info');
  }
  function delDef(party, job, ev) {
    ev.stopPropagation();
    const d = defs.find((x) => x.party === party && x.job === job);
    if (!d) return;
    if (!window.confirm('Delete definition "' + d.name + '"?')) return;
    setDefs((list) => list.filter((x) => !(x.party === party && x.job === job)));
    toast('Definition deleted', 'info');
  }

  /* ════════ RESET ════════ */
  function resetBuilder() {
    if (selected.length && !window.confirm('Reset the current definition?')) return;
    setSelected([]);
    setRepName('');
  }

  const abForLabel = (partyObj && jobObj) ? ' · for ' + partyObj.name + ' / ' + jobObj.name : (partyObj ? ' · for ' + partyObj.name : '');

  return (
    <div className="red-root">
      {/* <header className="red-hdr">
        <div className="red-logo">
          <div className="red-logo-mark">
            <svg viewBox="0 0 24 24"><path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm13.5 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" /></svg>
          </div>
          <div>
            <div className="red-logo-name">Saami <span>Tradestar</span></div>
            <div className="red-logo-pvt">Report Definition</div>
          </div>
        </div>
        <div className="red-hdr-user"><div className="red-hdr-av">AD</div>Admin</div>
      </header> */}

      {/* <div className="red-bc">
        <span>Reports</span><span className="red-bc-sep">›</span><span>Configuration</span><span className="red-bc-sep">›</span><span className="red-bc-cur">Report Definition</span>
      </div> */}

      <div className="red-page">
        <div className="red-pg-row">
          <div className="red-pg-title">
            <h1>Party / Job-wise Report Definition</h1>
            <p>Assign the fields each party &amp; job needs in their report — pick from the master list, order them, rename headers, and mark totals.</p>
          </div>
        </div>

        {/* SELECTION */}
        <div className="red-card">
          <div className="red-band red-navy-band">
            <div className="red-band-icon"><svg viewBox="0 0 24 24" strokeWidth="2"><path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2" /><circle cx="9" cy="7" r="4" /></svg></div>
            <div><div className="red-band-title">Report For</div><div className="red-band-sub">Choose the party and job this definition applies to</div></div>
          </div>
          <div className="red-card-body">
            <div className="red-g3">
              <div className="red-field">
                <label>Party <span className="red-req">*</span></label>
                <select value={curParty} onChange={(e) => partyChanged(e.target.value)}>
                  <option value="">— Select Party —</option>
                  {PARTIES.map((p) => <option key={p.code} value={p.code}>{p.name}</option>)}
                </select>
              </div>
              <div className="red-field">
                <label>Job <span className="red-req">*</span> <span className="red-hint-inline">{curParty ? `(${jobs.length} job${jobs.length !== 1 ? 's' : ''})` : '(select party first)'}</span></label>
                <select value={curJob} onChange={(e) => jobChanged(e.target.value)} disabled={!curParty}>
                  <option value="">— Select Job —</option>
                  {jobs.map((j) => <option key={j.code} value={j.code}>{j.code} · {j.name}</option>)}
                </select>
              </div>
              <div className="red-field">
                <label>Report Name</label>
                <input type="text" value={repName} onChange={(e) => setRepName(e.target.value)} placeholder="e.g. Monthly Consignment MIS" />
              </div>
            </div>
          </div>
        </div>

        {/* BUILDER */}
        <div className="red-card">
          <div className="red-band red-teal-band">
            <div className="red-band-icon"><svg viewBox="0 0 24 24" strokeWidth="2"><rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" /></svg></div>
            <div><div className="red-band-title">Field Assignment</div><div className="red-band-sub">Add fields from the master list, then order &amp; configure them</div></div>
            <div className="red-band-r">
              <button className="red-btn red-btn-ghost red-btn-xs" onClick={loadPreset} style={{ background: 'rgba(255,255,255,.15)', color: '#fff', borderColor: 'rgba(255,255,255,.3)' }}>Load Standard Set</button>
            </div>
          </div>
          <div className="red-card-body">
            <div className="red-xfer">
              {/* AVAILABLE */}
              <div className="red-xfer-col">
                <div className="red-xfer-head">
                  <span className="red-xh-title">Available Fields</span><span className="red-xh-count">{availFields.length}</span>
                  <div className="red-xh-r"><button className="red-btn red-btn-ghost red-btn-xs" onClick={addAll}>Add All</button></div>
                </div>
                <div className="red-xfer-search">
                  <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="8" /><path d="M21 21l-4.35-4.35" /></svg>
                  <input value={availSearch} onChange={(e) => setAvailSearch(e.target.value)} placeholder="Search fields…" />
                </div>
                <div className="red-xfer-body">
                  {!availFields.length ? (
                    <div className="red-xfer-empty"><div className="red-xe-ico">📋</div>{availSearch ? 'No matching fields' : 'All fields added'}</div>
                  ) : (
                    CATS.map((cat) => {
                      const items = availFields.filter((f) => f.cat === cat);
                      if (!items.length) return null;
                      return (
                        <div className="red-cat-group" key={cat}>
                          <div className="red-cat-h"><span>{cat}</span><span className="red-cat-add" onClick={() => addCat(cat)}>+ Add all</span></div>
                          {items.map((f) => (
                            <div className="red-avail-item" key={f.id} onClick={() => addField(f.id)}>
                              <span className="red-ai-plus">+</span>
                              <span className="red-ai-name">{f.name}</span>
                              <span className="red-ai-type">{f.type}</span>
                            </div>
                          ))}
                        </div>
                      );
                    })
                  )}
                </div>
              </div>

              {/* SELECTED */}
              <div className="red-xfer-col">
                <div className="red-xfer-head">
                  <span className="red-xh-title">Report Columns</span><span className="red-xh-count">{selected.length}</span>
                  <div className="red-xh-r"><button className="red-btn red-btn-ghost red-btn-xs" onClick={clearAll}>Clear</button></div>
                </div>
                <div className="red-xfer-search" style={{ color: 'var(--muted)', fontSize: '11px', justifyContent: 'center' }}>
                  Drag ⋮⋮ to reorder · edit header label · ✓ Σ for column totals
                </div>
                <div className="red-xfer-body">
                  {!selected.length ? (
                    <div className="red-xfer-empty"><div className="red-xe-ico">🗂️</div>Click fields on the left to add them as report columns</div>
                  ) : (
                    selected.map((s, i) => {
                      const f = fieldById(s.id) || { name: s.id, type: 'text' };
                      const isNum = f.type === 'num';
                      const itemClasses = ['red-sel-item'];
                      if (dragOverIdx === i) itemClasses.push('red-drag-over');
                      if (draggingIdx === i) itemClasses.push('red-dragging');
                      return (
                        <div
                          key={s.id}
                          className={itemClasses.join(' ')}
                          draggable="true"
                          onDragStart={() => dragStart(i)}
                          onDragOver={(e) => dragOver(e, i)}
                          onDragLeave={dragLeave}
                          onDrop={(e) => drop(e, i)}
                          onDragEnd={dragEnd}
                        >
                          <span className="red-sel-grip">⠿</span>
                          <span className="red-sel-seq">{i + 1}</span>
                          <div className="red-sel-main">
                            <div className="red-sel-name">{f.name} <span style={{ color: 'var(--muted)', fontSize: '9px' }}>· {f.type}</span></div>
                            <input className="red-sel-label" value={s.label} onChange={(e) => setLabel(i, e.target.value)} placeholder="Column header" />
                          </div>
                          <label className={'red-sel-total' + (isNum ? '' : ' red-dim')} title="Show column total">
                            <input type="checkbox" checked={s.total} disabled={!isNum} onChange={(e) => setTotal(i, e.target.checked)} /> Σ
                          </label>
                          <div className="red-sel-ctrls">
                            <button className="red-sc-btn" onClick={() => moveField(i, -1)} disabled={i === 0}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="18 15 12 9 6 15" /></svg></button>
                            <button className="red-sc-btn" onClick={() => moveField(i, 1)} disabled={i === selected.length - 1}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9" /></svg></button>
                            <button className="red-sc-btn red-rm" onClick={() => removeField(i)}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg></button>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* PREVIEW */}
        <div className="red-card">
          <div className="red-band red-blue-band">
            <div className="red-band-icon"><svg viewBox="0 0 24 24" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg></div>
            <div><div className="red-band-title">Report Preview</div><div className="red-band-sub">Columns in defined order with sample data</div></div>
            <div className="red-band-r"><span className="red-band-badge">{previewCols}</span></div>
          </div>
          <div className="red-card-body">
            {!selected.length ? (
              <div className="red-prev-empty"><div style={{ fontSize: '34px', opacity: .5 }}>👁️</div><div style={{ fontWeight: 700, color: 'var(--slate)', marginTop: '8px' }}>Add columns to preview the report</div></div>
            ) : (
              <div className="red-prev-scroll">
                <table className="red-prev-tbl">
                  <thead>
                    <tr>
                      {selected.map((s) => {
                        const f = fieldById(s.id) || { type: 'text' };
                        return <th key={s.id} className={f.type === 'num' ? 'red-num' : ''}>{s.label || f.name}</th>;
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {[0, 1].map((row) => (
                      <tr key={row}>
                        {selected.map((s) => {
                          const f = fieldById(s.id) || { type: 'text' };
                          return <td key={s.id} className={f.type === 'num' ? 'red-num' : ''}>{SAMPLE[s.id] !== undefined ? SAMPLE[s.id] : '—'}</td>;
                        })}
                      </tr>
                    ))}
                  </tbody>
                  {hasTotals && (
                    <tfoot>
                      <tr>
                        {selected.map((s, i) => {
                          const f = fieldById(s.id) || { type: 'text' };
                          if (i === 0) return <td key={s.id}>Total</td>;
                          return <td key={s.id} className={f.type === 'num' ? 'red-num' : ''}>{s.total ? (SAMPLE[s.id] || '') : ''}</td>;
                        })}
                      </tr>
                    </tfoot>
                  )}
                </table>
              </div>
            )}
          </div>
        </div>

        {/* SAVED */}
        <div className="red-card">
          <div className="red-band red-navy-band">
            <div className="red-band-icon"><svg viewBox="0 0 24 24" strokeWidth="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><polyline points="14 2 14 8 20 8" /></svg></div>
            <div><div className="red-band-title">Saved Report Definitions</div><div className="red-band-sub">Click to load &amp; edit</div></div>
            <div className="red-band-r"><span className="red-band-badge">{defs.length}</span></div>
          </div>
          <div style={{ overflowX: 'auto' }}>
            <table className="red-saved-tbl">
              <thead>
                <tr><th>Party</th><th>Job</th><th>Report Name</th><th className="red-c">Columns</th><th>Updated</th><th className="red-c">Action</th></tr>
              </thead>
              <tbody>
                {!defs.length ? (
                  <tr><td colSpan={6} style={{ textAlign: 'center', padding: '30px', color: 'var(--muted)' }}>No saved definitions yet</td></tr>
                ) : (
                  defs.map((d) => {
                    const p = PARTIES.find((x) => x.code === d.party) || { name: d.party };
                    const js = JOBS[d.party] || [];
                    const j = js.find((x) => x.code === d.job) || { name: d.job };
                    return (
                      <tr key={d.party + d.job} onClick={() => loadDef(d.party, d.job)}>
                        <td style={{ fontWeight: 700, color: 'var(--navy)' }}>{p.name}</td>
                        <td style={{ fontSize: '12px' }}>{j.name}<div style={{ fontSize: '10px', color: 'var(--muted)', fontFamily: "'JetBrains Mono',monospace" }}>{d.job}</div></td>
                        <td>{d.name}</td>
                        <td className="red-c"><span className="red-chip-count">{d.cols.length} cols</span></td>
                        <td style={{ color: 'var(--slate)', fontSize: '12px' }}>{d.updated}</td>
                        <td className="red-c"><button className="red-btn red-btn-ghost red-btn-xs" onClick={(e) => delDef(d.party, d.job, e)}>Delete</button></td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* ACTION BAR */}
      <div className="red-action-bar">
        <div className="red-ab-inner">
          <div className="red-ab-info"><b>{selected.length}</b> columns selected<span>{abForLabel}</span></div>
          <button className="red-btn red-btn-ghost" onClick={resetBuilder}>Reset</button>
          <button className="red-btn red-btn-green" onClick={saveDefinition}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v14a2 2 0 01-2 2z" /><polyline points="17 21 17 13 7 13 7 21" /><polyline points="7 3 7 8 15 8" /></svg>
            Save Report Definition
          </button>
        </div>
      </div>

      <div className="red-toast-wrap">
        {toasts.map((t) => (
          <div key={t.id} className={'red-toast red-' + t.type + (t.leaving ? ' red-toast-out' : '')}>
            <span style={{ fontSize: '15px' }}>{TOAST_ICONS[t.type] || 'ℹ'}</span>{t.msg}
          </div>
        ))}
      </div>
    </div>
  );
}